import { TRefElementInstance } from 'widgets/toolbox/RefElement';

/**
 * @description Core ProductVariantSelect implementation
 * @param ProductVariantSelect widget for extending
 * @returns Product Variant Select widget
 */

function CoreProductVariantSelectClassCreator(ProductVariantSelect: import('widgets/product/ProductVariantSelect').TProductVariantSelect) {
    /**
     * @class CoreProductVariantSelect
     * @augments ProductVariantSelect
     * @property {null | TRefElementInstance}
     */
    class CoreProductVariantSelect extends ProductVariantSelect {
        selectedVariation: null | TRefElementInstance = null;

        /**
         * @description saves selected variation to local field
         * @param variation - selected variation
         * @emits 'change'
         */
        selectVariation(variation: TRefElementInstance) {
            this.selectedVariation = variation;
            this.emit('change', this);

            if (this.id === 'attr-size') {
                this.eventBus().emit('sizeVariation.select');
            }

            if (this.id === 'attr-size' || this.id === 'attr-width') {
                this.ref('html').addClass('m-active_variation');
            }

            if (this.id === 'attr-size' || this.id === 'attr-width') {
                this.ref('html').removeClass('m-submit_error');
            }
        }
    }

    return CoreProductVariantSelect;
}

export type TCoreProductVariantSelect = ReturnType<typeof CoreProductVariantSelectClassCreator>;

export type TCoreProductVariantSelectInstance = InstanceType<TCoreProductVariantSelect>;

export default CoreProductVariantSelectClassCreator;
